// import PropTypes from "prop-types";
// import { useHistory } from "react-router-dom";
// import { roleModuleAction } from "./constants";

// const ShowForRoleComponent = ({ rol, moduleAction, accessPermission, children }) => {
//   const history = useHistory();
//   const rolActions = roleModuleAction.find((r) => r.Rol === rol);

//   const actionToCheck = accessPermission || moduleAction;
//   const hasPermission = !actionToCheck || (
//     rolActions?.Full || rolActions?.Actions.includes(actionToCheck)
//   );

//   if (accessPermission && !hasPermission) {
//     history.replace("/dashboard");
//     return null;
//   }
//   return hasPermission ? children : null;
// };

// ShowForRoleComponent.propTypes = {
//   rol: PropTypes.number.isRequired,
//   moduleAction: PropTypes.string,
//   accessPermission: PropTypes.string,
//   children: PropTypes.node
// };

// export const ShowForRole = ShowForRoleComponent;



import PropTypes from "prop-types";
import { roleModuleAction, PERMISSION_TO_MODULE_ID } from './constants';
import { useHistory } from "react-router-dom";

const ShowForRoleComponent = (props) => {
  const history = useHistory();
  const { rol, moduleAction, accessPermission, children, modules } = props;
  const rolActions = roleModuleAction.find((r) => r.Rol == rol);

  let show = false;
  const actionToCheck = accessPermission || moduleAction;

  let isModuleAllowed = true;
  if (accessPermission && modules) {
    const moduleId = PERMISSION_TO_MODULE_ID[accessPermission];
    if (moduleId && modules.hasOwnProperty(moduleId)) {
      isModuleAllowed = modules[moduleId];
    }
  }

  if (actionToCheck && rolActions && isModuleAllowed) {
    show = rolActions.Full || rolActions.Actions.includes(actionToCheck);
  }

  if (accessPermission) {
    if (show) {
      return children;
    }
    const redirectPath = rol === '8' ? "/supplier-management" : "/dashboard";
    history.replace(redirectPath);
  }

  if (moduleAction) {
    return show ? children : null
  }
  return null
};

ShowForRoleComponent.propTypes = {
  rol: PropTypes.number.isRequired,
  moduleAction: PropTypes.string,
  accessPermission: PropTypes.string,
  children: PropTypes.node
};

export const ShowForRole = ShowForRoleComponent;


/* import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { roleModuleAction } from "./constants";

const ShowForRoleComponent = ({ rol, accessPermission, moduleAction, children }) => {
  const history = useHistory();
  const rolNumber = Number(rol);
  const rolActions = roleModuleAction.find((r) => r.Rol === rolNumber);

  const hasPermission =
    (accessPermission === undefined && moduleAction === undefined) ||
      (accessPermission === null && moduleAction === null)
      ? true
      : rolActions?.Full ||
      (accessPermission && rolActions?.Actions.includes(accessPermission)) ||
      (moduleAction && rolActions?.Actions.includes(moduleAction));

  if (!hasPermission) {
    const redirectPath = rolNumber === 8 ? "/supplier-management" : "/dashboard";
    history.replace(redirectPath);
  }

  return hasPermission ? children : null;
};

ShowForRoleComponent.propTypes = {
  rol: PropTypes.number.isRequired,
  accessPermission: PropTypes.string,
  moduleAction: PropTypes.string,
};

export const ShowForRole = ShowForRoleComponent; */